import {Pair} from '../abstract-units';
import {Edge, Side} from '../edge';
import type {AxisEdgesWalker} from './axis-edges-walker';
import {SideCellsWalker} from './side-cells-walker';
import {SidedEdgesWalker} from './sided-edges-walker';

export class EdgeWalker {

    constructor(
        public edge: Edge
    ) {}

    public sideCells(side: Side): SideCellsWalker {
        return new SideCellsWalker(this.edge, side);
    }

    public sidedCrossAxisEdges(): Pair<AxisEdgesWalker> {
        return [
            this.sideCells(Side.FIRST).crossAxisEdges(),
            this.sideCells(Side.SECOND).crossAxisEdges()
        ];
    }

    public sidedEndingCrossEdges(): SidedEdgesWalker {
        const sidedEndingEdges = this.sidedCrossAxisEdges()
            .map(
                sideEdgesWalker => [
                    sideEdgesWalker.first().edge,
                    sideEdgesWalker.last().edge
                ]
            );

        return new SidedEdgesWalker([
            sidedEndingEdges[Side.FIRST],
            sidedEndingEdges[Side.SECOND]
        ]);
    }

    public sidedAdjoiningCrossEdges(): SidedEdgesWalker {
        const sidedAdjoiningEdges = this.sidedCrossAxisEdges()
            .map(
                sideEdgesWalker => sideEdgesWalker.middle().edges
            ) as Pair<Edge[]>;

        return new SidedEdgesWalker(sidedAdjoiningEdges);
    }
}
